module.exports = __webpack_public_path__ + "static/img/5.a28e083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/5.jpg
// module id = kQMb
// module chunks = 0